import { PDFDocument, PDFFont, StandardFonts, rgb  } from "pdf-lib";
import Invoice from "../common/models/Invoice.ts";
import InvoiceInformation from "../common/models/InvoiceInformation.ts";
import fontkit from '@pdf-lib/fontkit';
import { md5 } from "js-md5";
import { FRONTEND_SERVER } from "../common/env.ts";


let gbl_calibri_bold_font_bytes: Uint8Array<ArrayBufferLike>
let gbl_calibri_font_bytes: Uint8Array<ArrayBufferLike>

export async function load_pdf_fonts() {
    const loc_calibri_bold_font_response = await fetch(FRONTEND_SERVER + "/fonts/calibri-bold.ttf");
    gbl_calibri_bold_font_bytes = await loc_calibri_bold_font_response.bytes();

    const loc_calibri_font_response = await fetch(FRONTEND_SERVER + "/fonts/calibri-regular.ttf");
    gbl_calibri_font_bytes = await loc_calibri_font_response.bytes();
}

function string_to_width_and_remainder(
    string: string,
    font: PDFFont,
    font_size: number,
    width: number,
    use_elipsis: boolean
): [string, string] {
    if (string === "") {
        return ["", ""]
    }

    let rtn = string
    
    let words_popped = 0
    let words = string.split(' ')

    while (font.widthOfTextAtSize(rtn, font_size) > width) {
        words.pop()
        words_popped++

        rtn = words.join(' ')
        if (use_elipsis) {
            rtn += '...'
        }
    }

    if (words_popped === 0) {
        return [rtn, ""]
    } else {
        const remainder = string.split(' ')
            .slice(0 - words_popped)
            .join(' ')
        
        return [rtn, remainder]
    }
}

export async function stamp(
    arg_draw_x: number, 
    arg_draw_y: number, 
    arg_invoice_information: InvoiceInformation, 
    arg_pdf_bytes: Uint8Array<ArrayBufferLike>
): Promise<Uint8Array<ArrayBufferLike>> {
    const scale = 1.3333333333333333333333333333333
    const draw_x_scaled = arg_draw_x / scale
    const draw_y_scaled = arg_draw_y / scale

    const pdf_doc = await PDFDocument.load(arg_pdf_bytes)
    pdf_doc.registerFontkit(fontkit);

    const calibri_font = await pdf_doc.embedFont(gbl_calibri_font_bytes, { subset: true, features: { liga: false } })
    const calibri_bold_font = await pdf_doc.embedFont(gbl_calibri_bold_font_bytes, { subset: true, features: { liga: false } })

    const helvetica_font = await pdf_doc.embedFont(StandardFonts.Helvetica)
    const helvetica_bold_font = await pdf_doc.embedFont(StandardFonts.HelveticaBold)

    const pages = pdf_doc.getPages()
    const firstPage = pages[0]
    // const { width, height } = firstPage.getSize()

    if (arg_invoice_information.project_NaN.startsWith('1')) {
        firstPage.drawText('PO Number:', {
            x: 2 + draw_x_scaled,
            y: 65 + draw_y_scaled,
            size: 10,
            font: calibri_font,
            color: rgb(0.95, 0.1, 0.1),

        })

        firstPage.drawText(arg_invoice_information.project_NaN, {
            x: 55 + draw_x_scaled,
            y: 65 + draw_y_scaled,
            size: 10,
            maxWidth: 80,
            font: calibri_bold_font,
            color: rgb(0.95, 0.1, 0.1),

        })
    } else {
        firstPage.drawText('Project Number:', {
            x: 2 + draw_x_scaled,
            y: 65 + draw_y_scaled,
            size: 10,
            font: calibri_font,
            color: rgb(0.95, 0.1, 0.1),

        })

        firstPage.drawText(arg_invoice_information.project_NaN, {
            x: 72 + draw_x_scaled,
            y: 65 + draw_y_scaled,
            size: 10,
            maxWidth: 80,
            font: calibri_bold_font,
            color: rgb(0.95, 0.1, 0.1),

        })
    }

    firstPage.drawText('Project Manager: ', {
        x: 2 + draw_x_scaled,
        y: 52 + draw_y_scaled,
        size: 10,
        font: calibri_font,
        color: rgb(0.95, 0.1, 0.1),
    })

    firstPage.drawText(arg_invoice_information.project_manager, {
        x: 76 + draw_x_scaled,
        y: 52 + draw_y_scaled,
        size: 10,
        font: calibri_bold_font,
        color: rgb(0.95, 0.1, 0.1),
    })

    firstPage.drawText('Customer: ', {
        x: 2 + draw_x_scaled,
        y: 38 + draw_y_scaled,
        size: 10,
        font: calibri_font,
        color: rgb(0.95, 0.1, 0.1),
    })

    firstPage.drawText(arg_invoice_information.customer, {
        x: 46 + draw_x_scaled,
        y: 38 + draw_y_scaled,
        size: 10,
        font: calibri_bold_font,
        color: rgb(0.95, 0.1, 0.1),
    })


    if (arg_invoice_information.project_NaN.startsWith('1')) {
        firstPage.drawText('Purchase Description:', {
            x: 2 + draw_x_scaled,
            y: 25 + draw_y_scaled,
            size: 10,
            font: calibri_font,
            color: rgb(0.95, 0.1, 0.1),

        })

        const [first_line, first_line_remainder] = string_to_width_and_remainder(arg_invoice_information.project_description, calibri_bold_font, 10, 115, false)
        const [second_line, _] = string_to_width_and_remainder(first_line_remainder, calibri_bold_font, 10, 204, false)
        firstPage.drawText(first_line, {
            // x: 73 + draw_x_scaled,
            x: 92 + draw_x_scaled,
            y: 25 + draw_y_scaled,
            size: 10,
            font: calibri_bold_font,
            color: rgb(0.95, 0.1, 0.1),

        })
        firstPage.drawText(second_line, {
            x: 3 + draw_x_scaled,
            y: 13 + draw_y_scaled,
            size: 10,
            font: calibri_bold_font,
            color: rgb(0.95, 0.1, 0.1),

        })
    } else {
        firstPage.drawText('Project Description:', {
            x: 2 + draw_x_scaled,
            y: 25 + draw_y_scaled,
            size: 10,
            font: calibri_font,
            color: rgb(0.95, 0.1, 0.1),

        })

        const [first_line, first_line_remainder] = string_to_width_and_remainder(arg_invoice_information.project_description, calibri_bold_font, 10, 120, false)
        const [second_line, _] = string_to_width_and_remainder(first_line_remainder, calibri_bold_font, 10, 204, false)
        firstPage.drawText(first_line, {
            // x: 73 + draw_x_scaled,
            x: 84 + draw_x_scaled,
            y: 25 + draw_y_scaled,
            size: 10,
            font: calibri_bold_font,
            color: rgb(0.95, 0.1, 0.1),

        })

        firstPage.drawText(second_line, {
            x: 3 + draw_x_scaled,
            y: 13 + draw_y_scaled,
            size: 10,
            font: calibri_bold_font,
            color: rgb(0.95, 0.1, 0.1),

        })
    }

    firstPage.drawRectangle({
        x: draw_x_scaled,
        y: 7 + draw_y_scaled,
        width: 210,
        height: 68,
        // rotate: degrees(-15),
        borderWidth: 1,
        borderColor: rgb(1,0,0),
        opacity: 0,
    })

    return await pdf_doc.save();
    
}

export async function break_pdf_into_pages(pdf_bytes: Uint8Array<ArrayBufferLike>): Promise<Uint8Array<ArrayBufferLike>[]> {
    const pdf_doc = await PDFDocument.load(pdf_bytes)
    const pdf_doc_page_indices = pdf_doc.getPageIndices()

    const array_pdf_doc_pages: Uint8Array<ArrayBufferLike>[] = []

    for (let pdf_doc_page_index of pdf_doc_page_indices) {
        let single_page_pdf_doc = await PDFDocument.create()
        
        const copied_pages = await single_page_pdf_doc.copyPages(pdf_doc, [pdf_doc_page_index])
        for (const copied_page of copied_pages) {
            await single_page_pdf_doc.addPage(copied_page)
        }

        array_pdf_doc_pages.push(await single_page_pdf_doc.save())
    }

    return array_pdf_doc_pages
}

export async function return_pdf_pages_in_new_pdf(pdf_bytes: Uint8Array<ArrayBufferLike>, page_numbers: number[]): Promise<Uint8Array<ArrayBufferLike>> {
    const pdf_doc = await PDFDocument.load(pdf_bytes)

    let loc_pdf_pages_doc = await PDFDocument.create()
    const copied_pages = await loc_pdf_pages_doc.copyPages(pdf_doc, page_numbers)
    for (const copied_page in copied_pages) {
        await loc_pdf_pages_doc.addPage(copied_pages[copied_page])
    }

    return await loc_pdf_pages_doc.save()
}

export async function remove_page_from_pdf(pdf_bytes: Uint8Array<ArrayBufferLike>, page_number: number): Promise<Uint8Array<ArrayBufferLike>> {
    const pdf_doc = await PDFDocument.load(pdf_bytes)
    pdf_doc.removePage(page_number)

    return await pdf_doc.save()
}

export async function merge_invoice_pdfs(invoices: Invoice[], use_stamped_pdf: boolean): Promise<Uint8Array<ArrayBufferLike>> {
    let merged_pdf = await PDFDocument.create()

    for (const invoice of invoices) {
        const pdf_bytes_to_use = use_stamped_pdf ? invoice.stamped_pdf_bytes : invoice.pdf_bytes

        if (pdf_bytes_to_use !== null) {
            const current_pdf = await PDFDocument.load(pdf_bytes_to_use);
            const copied_pages = await merged_pdf.copyPages(current_pdf, current_pdf.getPageIndices());
            for (const page of copied_pages) {
                await merged_pdf.addPage(page)
            }
        }
    }

    return await merged_pdf.save()
}

export async function deduplicate_pages(pdf_bytes: Uint8Array): Promise<Uint8Array> {
    interface PdfPageWithPageNumber {
        pdf_bytes: Uint8Array<ArrayBufferLike>,
        page_number: number
    }

    const loc_pdf_pages = await break_pdf_into_pages(pdf_bytes)
    const loc_pdf_pages_with_md5_and_page_number: Array<PdfPageWithPageNumber> = []

    const loc_md5_sums: Array<string> = []
    const loc_duplicated_pages: Array<number> = []

    for (let tmp_page_index in loc_pdf_pages) {
        const tmp_md5 = md5(loc_pdf_pages[tmp_page_index])
        loc_pdf_pages_with_md5_and_page_number.push({
            pdf_bytes: loc_pdf_pages[tmp_page_index],
            page_number: parseInt(tmp_page_index),
        })

        if (loc_md5_sums.includes(tmp_md5)) {
            loc_duplicated_pages.push(parseInt(tmp_page_index))
        }
        loc_md5_sums.push(tmp_md5)
    }

    const loc_deduplicated_pdf_pages = loc_pdf_pages_with_md5_and_page_number
        .filter((tmp_pdf_page_with_md5_and_page_number) => {
            return !loc_duplicated_pages.includes(tmp_pdf_page_with_md5_and_page_number.page_number)
        })
        .map((tmp_pdf_page_with_md5_and_page_number) => {
            return tmp_pdf_page_with_md5_and_page_number.pdf_bytes
        })

    let merged_pdf = await PDFDocument.create()

    for (const tmp_deduplicated_pdf_page of loc_deduplicated_pdf_pages) {
        const current_pdf = await PDFDocument.load(tmp_deduplicated_pdf_page);
        const copied_pages = await merged_pdf.copyPages(current_pdf, current_pdf.getPageIndices());
        for (const page of copied_pages) {
            await merged_pdf.addPage(page)
        }
    }

    return await merged_pdf.save()
}